const ter = {
	state:{
		ter_param: null,
    edit_change: 'false'
	},
	mutations:{
		SET_TER_PARAM:(state,obj) => {
			state.ter_param = obj
		},
    SET_EDIT_CHANGE:(state,bool) => {
      state.edit_change = bool
    }
	},
	actions:{
		setTerParam:({commit},obj) => {
			commit('SET_TER_PARAM',obj)
		},
    setEditChange:({commit},bool) => {
      commit('SET_EDIT_CHANGE',bool)
    }
	}
}

export default ter



// WEBPACK FOOTER //
// ./src/vuex/modules/ter.js